import { Box, Stack } from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en-gb';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import './App.css';
import BackgroundImage from './assets/images/background.png';
import SnackbarContext from './components/SnackbarContext';
import { StyleConstants } from './Styles';
import Top from './Top';
import Menu from './Menu';

const Layout = () => {
    const [openSnackbar, setOpenSnackBar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                <SnackbarContext.Provider value={{ setOpenSnackBar, setSnackbarSeverity, setSnackbarMessage }}>
                    <Box sx={{ width: '1920px', height: '1080px', backgroundColor: StyleConstants.mainBgColor, margin: '0px', flexGrow: 1, backgroundImage: 'url(' + BackgroundImage + ')' }}>
                        <Stack direction="column">
                            <Top />
                            <Stack direction="row" sx={{ height: 'calc(1080px - 55px - 3px)' }}>
                                <Outlet />

                                <Menu />
                            </Stack>
                        </Stack>
                        <Snackbar
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            open={openSnackbar}
                            autoHideDuration={5000}
                            onClose={() => {
                                setOpenSnackBar(false);
                            }}
                        >
                            <Alert
                                onClose={() => {
                                    setOpenSnackBar(false);
                                }}
                                severity={snackbarSeverity}
                                variant="filled"
                                sx={{ fontSize: '24px', alignItems: 'center' }}
                            >
                                {snackbarMessage}
                            </Alert>
                        </Snackbar>
                    </Box>
                </SnackbarContext.Provider>
            </LocalizationProvider>
        </>
    );
};

export default Layout;